"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _colorInput["default"];
  }
});

var _colorInput = _interopRequireDefault(require("./color-input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }